export enum AppLanguage {
  Dutch = 'nl',
}
